// extracted by mini-css-extract-plugin
export default {"nowrap":"Result_nowrap__AC23-","bgSecondary":"Result_bgSecondary__Zno4c"};